<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open = false">
					<v-icon medium>fal fa-times</v-icon>
				</button>
				<!-- <v-spacer></v-spacer>
				<button type="button" class="btn-flat-icon--dark" @click="">
					<v-icon medium>fal fa-heart</v-icon>
				</button> -->
			</v-card-title>
			<v-card-text class="pt-0 pl-4 pr-4 event-page__modal-card-text text-xs-center" v-if="getUserObject">
				<div>
					<div>
						<div class="event-page-host-container" style="margin-bottom: -16px;">
							<div class="host-divider">
							</div>
							<div class="white host-circle">
								<div :style="{'background-image': 'url(' + getUserObject.avatar + ')'}" class="host-image"></div>
							</div>
						</div>
					</div>
					<p class="event-page-content-light">
						<b>{{getUserObject.first_name}}</b>
						<span v-if="userDenied" class="error--text"><br>Guest Denied</span>
					</p>
					<div v-if="userPending">
						<v-btn flat class="success" @click="approveGuest(getUserObject.uuid)">Approve</v-btn>
						<v-btn flat class="error" @click="denyGuest(getUserObject.uuid)">Deny</v-btn>
					</div>
					<!-- <div v-else-if="userDenied">
						<v-btn flat class="success" @click="approveGuest(getUserObject.uuid)">Cancel Deny</v-btn>
					</div> -->
					<p class="event-page-content" style="padding: 0px 10%;">
						{{getUserObject.bio}}
					</p>
					<p class="event-page-content" v-if="userInAddon(getUserObject.pk)">
						This guest is attending your {{event.addons[0].title}} add-on
					</p>
				</div>
				<div>
					<p class="event-page-sub-heading mt-5"><a @click="contactGuestModal=true">Contact Guest</a></p>
					<img class="event-page-flat-logo mb-4 mt-4" src="/static/images/wrkprty-flattened-logo.png" alt="">
					<p class="event-page-sub-heading-small mb-5"><a @click="reportEventModal=true">Report this Location, Event, or Host</a></p>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
export default {
	name: 'eventGuestModal',
	methods: {
		...mapActions(['setModalOpen', 'setEventProp']),
		userInAddon(pk) {
			if (this.event.addons.length > 0) {
				if (this.event.addons[0].attendees) {
					if (this.event.addons[0].attendees.includes(pk)) {
						return true
					}
				}
			}
			return false
		},
		approveGuest(guestUUID) {
			axios
				.get(
					'/api/v1/event/' +
						this.event.slug +
						'/approve-guest/' +
						guestUUID +
						'/'
				)
				.then(response => {
					console.log(response)
					let userObj = this.event.pending_attendees.find(
						obj => obj.uuid === guestUUID
					)
					let newArray = this.event.pending_attendees.slice(0)
					newArray.splice(this.event.pending_attendees.indexOf(userObj), 1)
					this.setEventProp({
						uuid: this.event.uuid,
						prop: 'pending_attendees',
						value: newArray
					})
					this.setEventProp({
						uuid: this.event.uuid,
						prop: 'attendees',
						value: this.event.attendees.concat(userObj)
					})
				})
				.catch(error => {
					console.error(error)
				})
		},
		denyGuest(guestUUID) {
			this.setModalOpen({ prop: 'denyGuestConfirmationModal', value: true })
		}
	},
	computed: {
		...mapGetters(['getModalProp', 'getAllEvents']),
		userPending() {
			if (this.event.pending_attendees.includes(this.getUserObject)) {
				return true
			}
		},
		userDenied() {
			if (this.event.denied_attendees.includes(this.getUserObject)) {
				return true
			}
		},
		getUserObject() {
			let attendees = this.event.attendees.concat(
				this.event.pending_attendees,
				this.event.denied_attendees
			)
			console.log(attendees)
			let userObj = attendees.find(obj => obj.uuid === this.guestModalIndex)
			return userObj
		},
		open: {
			get() {
				return this.getModalProp('eventGuestModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventGuestModal', value: val })
			}
		},
		contactGuestModal: {
			get() {
				return this.getModalProp('eventContactGuestModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventContactGuestModal', value: val })
			}
		},
		reportEventModal: {
			get() {
				return this.getModalProp('eventReportEventModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventReportEventModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		guestModalIndex() {
			return this.getModalProp('eventGuestModalIndex')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
